import request from './request'

/**
 * 获取公开配置
 * @returns {Promise}
 */
export function getPublicConfig() {
  return request({
    url: '/config/public',
    method: 'get'
  })
}

/**
 * 获取模块访问控制规则
 * @returns {Promise}
 */
export function getModuleAccessRules() {
  return request({
    url: '/config/module-access',
    method: 'get'
  })
}

/**
 * 获取插件访问控制规则
 * @returns {Promise}
 */
export function getPluginAccessRules() {
  return request({
    url: '/config/plugin-access',
    method: 'get'
  })
}
